/**
 * Custom hook for the agent hero component
 * @param {array} agentMedia - The array of objects containing an agent's media.
 * @returns Data used by the agent hero component
 */
export const useAgentHero = ({ agentMedia: rawMedia }) => {
    const basePath = `https://cdn.lakehomes.com/media`;
    const agentMedia = rawMedia === "" ? [] : rawMedia;

    const mediaType = agentMedia.reduce((acc, item) => {
        const { type, mediaUri } = item;
        if (type && mediaUri) {
            acc[`${type}Path`] = `${basePath}/${item.mediaUri}`;
        }
        return acc;
    }, {});

    const { heroDesktopPath, heroMobilePath } = mediaType;
    const hasHeroImage = !!(heroMobilePath || heroDesktopPath);

    return {
        heroDesktopPath,
        heroMobilePath,
        hasHeroImage,
    };
};
